import { RootState } from '../../store/rootReducer';

export const LegalNoticeContentSelector = (state: RootState) => state.content.legalNotice;
